import React, { Component, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink, faPlus, faMinus, faSearch, faCheck, faTimes, faRedo } from '@fortawesome/free-solid-svg-icons'

import SelectBox from '../SelectBox'

// 기본 데이터 요소
const defaultData = {
  value : "",
  startText : "",
  endText : "",
}

class InputBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value : defaultData.value,
      startText : defaultData.startText,
      endText : defaultData.endText,
      isGroup : false,
    }
  }

  componentDidMount() {
    this.props.value && this.setState({ value : this.props.value })
    this.props.startText && this.setState({ startText : this.props.startText })
    this.props.endText && this.setState({ endText : this.props.endText })

    this.checkGroup()
  }

  checkGroup = () => {
    // let isGroup = (
    //   this.props.isLink || 
    //   this.state.startText || 
    //   this.state.endText ||
    //   this.props.isSearch ||
    //   this.props.isPlus ||
    //   this.props.isMinus ||
    //   this.props.isCheck ||
    //   this.props.isRefresh
    // ) ? true : false

    if ((this.props.isLink != undefined && this.props.isLink) ||
        (this.props.isSearch != undefined && this.props.isSearch) ||
        (this.props.isPlus != undefined && this.props.isPlus) ||
        (this.props.isMinus != undefined && this.props.isMinus) ||
        (this.props.isCheck != undefined && this.props.isCheck) ||
        (this.props.isRefresh != undefined && this.props.isRefresh) ||
        (this.state.startText != "") || 
        (this.state.endText != "") ) 
    {
      this.setState({ isGroup : true })
    }
  }

  goUrl = (ref) => {
    if (this.refs[ref]) {
      window.open(this.refs[ref].value, "_blank")
    }
  }

  onClick = (type) => {
    this.props.clickEvent(type)
  }

  onChange = (e) => {
    console.log(e);
  };

  addInput = () => {
    // console.log("인풋박스 추가하기")
    this.props.addInputEvent()
  }

  removeInput = () => {
    // console.log("인풋박스 제거하기")
    // console.log("ref")
    // console.log(this.props.title)
    // console.log("ref")
    this.props.removeInputEvent(this.props.title)
  }

  render() {
    const { onClick, goUrl, addInput, removeInput } = this
    
    // console.log(this.props)
    // console.log(this.props)
    // console.log("isSearch : " + this.props.isSearch)
    // console.log("isPlus : " + this.props.isPlus)
    // console.log("isMinus : " + this.props.isMinus)
    // console.log("isCheck : " + this.props.isCheck)
    // console.log("isRefresh : " + this.props.isRefresh)
    // console.log("startText : " + this.state.startText)
    // console.log("endText : " + this.state.endText)

    // console.log("this.checkGroup : " + checkGroup)

    return (
      <>
        <div className={`${(this.state.isGroup) ? "input-group" : ""} ${this.props.index > 0 ? "mt-2" : ""}`}>
          {
            this.props.startText && (
              <span className="input-group-text">
                {this.props.startText}
              </span>
            )
          }
          {
            this.props.preAddOnSelctbox && (
              <SelectBox 
                OptionData={this.props.preAddOnSelctbox}
              />
            )
          }
          <input 
            type="text" 
            id="input" 
            ref="refInputBox"
            className="form-control" 
            value={this.state.value} 
            onChange={this.onChange}
            placeholder={this.props.placeHolder}
          />
          {
            this.props.endText && (
              <span className="input-group-text">
                {this.props.endText}
              </span>
            )
          }
          {
            this.props.isLink && (
              <button className="btn btn-outline-secondary btn-sm" type="button" id="" onClick={() => goUrl("refInputBox")}>
                <FontAwesomeIcon icon={faLink} />
              </button>
            )
          }
          {
            this.props.isRefresh && (
              <button className="btn btn-outline-secondary btn-sm" type="button" id="">
                <FontAwesomeIcon icon={faRedo} />
              </button>
            )
          }

          {
            this.state.isGroup && (
              <div className="btn-group ml-2">
                {
                  this.props.isSearch && (
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => onClick("search")}>
                      <FontAwesomeIcon icon={faSearch} />
                    </button>
                  )
                }
                {
                  this.props.isPlus && (
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={addInput}>
                      <FontAwesomeIcon icon={faPlus} />
                    </button>
                  )
                }
                {
                  this.props.isMinus && (
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={removeInput} disabled={this.props.index == undefined ? "true" : ""}>
                      <FontAwesomeIcon icon={faMinus} />
                    </button>
                  )
                }
                {
                  this.props.isCheck && (
                    this.props.checked ? (
                      <span className="input-group-text">
                        <FontAwesomeIcon icon={faCheck} />
                      </span>
                    ) : (
                      <span className="input-group-text">
                        <FontAwesomeIcon icon={faTimes} />
                      </span>
                      
                    )
                  )
                }
              </div>
            )
          }
        </div>
        {
          this.props.description &&
          <label className="form-label">{this.props.description}</label>
        }
      </>
    )
  }
}

export default InputBox;
